import React from "react";

function Footer() {
  return (
    <footer className="bg-dark text-white py-4 mt-auto">
      <div className="container text-center">
        <p className="mb-1">
          &copy; {new Date().getFullYear()} WebVenly. All rights reserved.
        </p>
        <p className="mb-0 small text-light">
          Powered by <strong>Wyatt Multi Solutions</strong>
        </p>
      </div>
    </footer>
  );
}

export default Footer;
